import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { STATUS_API } from 'src/app/constant/config';
import axios from '../app/axiosInterceptor';
import instance from 'src/app/axiosInterceptor';
import Cookie from 'js-cookie';
import { roles } from 'src/app/constant/roles';
export const Login = createAsyncThunk(
  'AuthSlice/login',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/auth/login`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: payload
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const GetUserInfo = createAsyncThunk(
  'User/GetInfo',
  async (_, { rejectWithValue }) => {
    try {
      const res = await instance.get('/users/information');
      return res.data;
    } catch (err) {
      if (!err.response) {
        return rejectWithValue(err.message || 'Network Error');
      }
      return rejectWithValue(err.response.data || 'Unknown error');
    }
  }
);

export const UpdateInfoBySelf = createAsyncThunk(
  'User/UpdateInfoBySelf',
  (payload, { rejectWithValue }) => {
    // const {id , ...updateData} = payload
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/auth/update/self`,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        },
        data: payload
      })
        .then(res => resolve(payload))
        .catch(err => {
          if (!err.response) reject(err?.message);
          reject(rejectWithValue(err.response?.data || null));
        });
    });
  }
);
export const Register = createAsyncThunk(
  'AuthSlice/register',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/auth/register`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: payload
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const ChangePassword = createAsyncThunk(
  'AuthSlice/ChangePassword',
  ({ new_password, id }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/auth/password/${id}`,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        },
        data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const authSlice = createSlice({
  name: 'authSlice',
  initialState: {
    isLoadingLogin: false,
    failStatus: null,
    dataLogin: null,
    isLogin: false,
    //  state for register
    isLoadingRegister: false,
    failRegisterStatus: null,
    dataRegister: null,
    isRegisterSuccess: false,
    // state for case reload
    isGettingInfo: false,
    errGetting: null,
    // update user by self
    isUpdatingInfoBySelf: false,
    isUpdateBySelfSuccess: false,
    errUpdateBySelf: null,
    isChangePassword: STATUS_API.PENDING,
    errorChangePassword: null,
    isLoadingChangePassword: false,

    isAdmin: false,
    isAgency: false,
    isStaff: false,
    isUser: false,
    isAccountant: false,
    isSale: false,
    isTechnician: false,
    isDriver: false,
    agencyId: null,
    agencyLevel: null,
    userId: null,
    adminId: null,
    driverId: null,
    idSocket: null,
  },
  reducers: {
    logOutAction: state => {
      state.isLogin = false;
      state.failStatus = null;
      Cookie.remove('access-token');
      localStorage.removeItem('access-token');
      localStorage.removeItem('agency-id');
      localStorage.removeItem('refresh-token');
    },
    loginSuccessAction: state => {
      state.isLogin = true;
    },
    finishRegisterAction: state => {
      state.isRegisterSuccess = false;
    },
    clearMassageErrorAction: state => {
      state.failStatus = null;
      state.failRegisterStatus = null;
    },
    clearMsgUpdate: state => {
      state.errUpdateBySelf = null;
      state.isUpdateBySelfSuccess = false;
    },
    resetChangePassword: state => {
      state.isChangePassword = STATUS_API.PENDING;
      state.isLoadingChangePassword = false;
    }
  },
  extraReducers: {
    [Login.pending]: state => {
      state.isLoadingLogin = true;
      state.errGetting = null;
      state.failStatus = null;
    },
    [Login.fulfilled]: (state, action) => {
      state.isLoadingLogin = false;
      state.dataLogin = action.payload.payload.user;
      state.failStatus = null;

      const user = action.payload.payload.user;
      state.isAdmin =
        user && user.role && user.role.title === roles.ADMIN ? true : false;
      state.isAgency =
        user && user.role && user.role.title === roles.AGENCY ? true : false;
      state.isStaff =
        user && user.role && user.role.title === roles.STAFF ? true : false;
      state.isUser =
        user && user.role && user.role.title === roles.ENDUSER ? true : false;
      state.isAccountant =
        user && user.role && user.role.title === roles.ACCOUNTANT ? true : false;
      state.isSale =
        user && user.role && user.role.title === roles.SALE ? true : false;
      state.isTechnician =
        user && user.role_id === 8 ? true : false;
      state.isDriver =
        user && user.role_id === 10 ? true : false;
      state.agencyId =
        user && user.role && user.role.title === roles.AGENCY
          ? user.agency.id
          : undefined;
      state.agencyLevel =
        user && user.role && user.role.title === roles.AGENCY
          ? (Number(user.agency.level) || null)
          : null;
      state.userId =
        user && user.role && user.role.title === roles.ENDUSER
          ? user.endUser.id
          : undefined;
      state.adminId =
        user && user.role && user.role.title === roles.ADMIN
          ? user.id
          : undefined;
      state.driverId =
        user && user.role_id === 10
          ? user.id
          : undefined;
      state.idSocket = user.id || undefined;

      state.isLogin = true;
      Cookie.set('access-token', action.payload.payload['token']);
      localStorage.setItem('access-token', action.payload.payload['token']);
      localStorage.setItem(
        'refresh-token',
        action.payload.payload['refresh_token']
      );

      if (action.payload.payload.user.agency != null)
        localStorage.setItem(
          'agency-id',
          action.payload.payload.user.agency.id
        );
    },
    [Login.rejected]: (state, action) => {
      console.log(action);
      state.isLoadingLogin = false;
      state.failStatus = {
        message: 'Đăng nhập thất bại vui lòng kiểm tra lại thông tin',
      };
    },
    // register call api
    [Register.pending]: state => {
      state.isLoadingRegister = true;
      state.errGetting = null;
    },
    [Register.fulfilled]: (state, action) => {
      state.isLoadingRegister = false;
      state.dataRegister = action.payload.payload;
      state.isRegisterSuccess = true;
      Cookie.set('access-token', action.payload.payload['access-token']);
    },
    [Register.rejected]: (state, action) => {
      state.isLoadingRegister = false;
      state.failRegisterStatus = action.payload || action.error;
    },
    // get user info api
    [GetUserInfo.pending]: state => {
      state.isGettingInfo = true;
      state.errGetting = null;
    },
    [GetUserInfo.fulfilled]: (state, action) => {
      state.isGettingInfo = false;
      state.dataLogin = action.payload.payload.user;
      const user = action.payload.payload.user;
      state.isAdmin =
        user && user.role && user.role.title === roles.ADMIN ? true : false;
      state.isAgency =
        user && user.role && user.role.title === roles.AGENCY ? true : false;
      state.isUser =
        user && user.role && user.role.title === roles.ENDUSER ? true : false;
      state.isStaff =
        user && user.role && user.role.title === roles.STAFF ? true : false;
      state.isAccountant =
        user && user.role && user.role.title === roles.ACCOUNTANT ? true : false;
      state.isSale =
        user && user.role && user.role.title === roles.SALE ? true : false;
      state.isTechnician =
        user && user.role_id === 8 ? true : false;
      state.agencyId =
        user && user.role && user.role.title === roles.AGENCY
          ? user.agency.id
          : undefined;
      state.isDriver =
        user && user.role_id === 10 ? true : false;
      state.driverId =
        user && user.role_id === 10
          ? user.id
          : undefined;
      state.agencyLevel =
        user && user.role && user.role.title === roles.AGENCY
          ? (Number(user.agency.level) || null)
          : null;
      state.userId =
        user && user.role && user.role.title === roles.ENDUSER
          ? user.endUser.id
          : undefined;
      state.idSocket = user.id || undefined;
      state.adminId =
        user && user.role && user.role.title === roles.ADMIN
          ? user.id
          : undefined;
      state.isLogin = true;
    },
    [GetUserInfo.rejected]: (state, action) => {
      state.isGettingInfo = false;
      state.errGetting = action.payload || action.error;
    },
    //   update user by self
    [UpdateInfoBySelf.pending]: state => {
      state.isUpdatingInfoBySelf = true;
      state.errUpdateBySelf = null;
      state.isUpdateBySelfSuccess = false;
      state.errGetting = null;
    },
    [UpdateInfoBySelf.fulfilled]: (state, action) => {
      state.isUpdatingInfoBySelf = false;
      state.isUpdateBySelfSuccess = true;
      state.dataLogin = action.payload;
    },
    [UpdateInfoBySelf.rejected]: (state, action) => {
      state.isUpdatingInfoBySelf = false;
      state.errUpdateBySelf = action.payload?.message || action.error;
    },
    //   Change password
    [ChangePassword.pending]: state => {
      state.isLoadingChangePassword = true;
      state.errorChangePassword = null;
      state.isChangePassword = STATUS_API.PENDING;
    },
    [ChangePassword.fulfilled]: (state, action) => {
      state.isLoadingChangePassword = false;
      state.errorChangePassword = null;
      state.isChangePassword = STATUS_API.SUCCESS;
    },
    [ChangePassword.rejected]: (state, action) => {
      state.isLoadingChangePassword = false;
      state.isChangePassword = STATUS_API.ERROR;
      state.errorChangePassword = action.payload?.message || action.error;
    }
  }
});
export const {
  logOutAction,
  loginSuccessAction,
  finishRegisterAction,
  clearMassageErrorAction,
  clearMsgUpdate,
  resetChangePassword
} = authSlice.actions;

export default authSlice.reducer;
